import { render } from "./CattleInfo.vue?vue&type=template&id=57dbe50d"
import script from "./CattleInfo.vue?vue&type=script&lang=js"
export * from "./CattleInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__